export function getGuestId() {
  let id = localStorage.getItem("dm_guest_id");
  if (!id) {
    id =
      (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
      `guest-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("dm_guest_id", id);
  }
  return id;
}

const PENDING_KEY = "dm_pending_pairing";

export function setPendingPairing(pairing) {
  try {
    localStorage.setItem(PENDING_KEY, JSON.stringify(pairing));
  } catch (e) {
    console.warn("Could not persist pending pairing:", e);
  }
}

export function getPendingPairing() {
  try {
    const raw = localStorage.getItem(PENDING_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearPendingPairing() {
  localStorage.removeItem(PENDING_KEY);
}
